import React from "react";
import { Editor } from "primereact/editor";
import "./custom-editor.css";

const TabDetail = ({ data, onInputChange }) => {
  const handleContentChange = (e) => {
    onInputChange("description", e.htmlValue);
  };

  const handleNoteChange = (e) => {
    onInputChange("notes", e.target.value);
  };

  return (
    <div className="mt-6">
      <Editor
        value={data.description}
        onTextChange={handleContentChange}
        style={{ height: "100px", borderRadius: "0 0 8px 8px" }}
      />
      <div className="border rounded-lg mt-6">
        <p className="border-b p-2 w-full">Ghi chú</p>
        <textarea
          className="w-full p-4 h-[80px]"
          value={data.notes}
          onChange={handleNoteChange}
        ></textarea>
      </div>
    </div>
  );
};

export default TabDetail;
